export const getCurrentHash = (): string | null => null
